export const reviewModesContent = `
Choose the depth of analysis that matches your needs. Each mode consumes a different number of credits.

{% card title="Quick — 1 credit (~10 seconds)" %}
Fast surface-level check for obvious ambiguities, missing acceptance criteria, and vague language. Best for initial drafts.
{% /card %}

{% card title="Standard — 3 credits (~30 seconds)" %}
Comprehensive review including dependency analysis, assumption detection, edge case identification, and rewritten suggestions.
{% /card %}

{% card title="Deep — 5 credits (~60 seconds)" %}
Full analysis with persona-based feedback, cross-requirement consistency checks, risk assessment, and prioritised recommendations.
{% /card %}
`;
